<template>
  <div class="participant-card">
    <img v-if="isRiseupCustomer" class="riseup-badge" :src="require('@/assets/challenge/riseup-badge.svg')"/>
    <div class="icon-circle" :style="{ backgroundColor: ICON_COLOR_MAPPING[participant.icon] }">
      <img class="icon" :src="require(`@/assets/challenge/${participant.icon}.svg`)"/>
    </div>
    <div class="name">{{ participant.firstName }}</div>
    <div class="spent">₪{{ participant.spent }}</div>
  </div>
</template>

<script>

const AVAILABLE_PARTICIPANT_ICONS = {
  PIZZA: 'pizza',
  BURGER: 'burger',
  FRIES: 'fries',
  CROISSANT: 'croissant',
  PRETZEL: 'pretzel',
  DONUT: 'donut',
  SANDWICH: 'sandwich',
  TAKEOUT: 'takeout',
  ICE_CREAM: 'iceCream',
  BURRITO: 'burrito',
  PITTA: 'pitta',
};

const ICON_COLOR_MAPPING = {
  [AVAILABLE_PARTICIPANT_ICONS.PIZZA]: '#4244AF',
  [AVAILABLE_PARTICIPANT_ICONS.BURGER]: '#FFCEB9',
  [AVAILABLE_PARTICIPANT_ICONS.FRIES]: '#2A5E55',
  [AVAILABLE_PARTICIPANT_ICONS.CROISSANT]: '#FFCF03',
  [AVAILABLE_PARTICIPANT_ICONS.PRETZEL]: '#00C070',
  [AVAILABLE_PARTICIPANT_ICONS.DONUT]: '#EB73EF',
  [AVAILABLE_PARTICIPANT_ICONS.SANDWICH]: '#5D7AFD',
  [AVAILABLE_PARTICIPANT_ICONS.TAKEOUT]: '#FF7E14',
  [AVAILABLE_PARTICIPANT_ICONS.ICE_CREAM]: '#B44399',
  [AVAILABLE_PARTICIPANT_ICONS.BURRITO]: '#DCE8F6',
  [AVAILABLE_PARTICIPANT_ICONS.PITTA]: '#CFEADD',
};

export default {
  name: 'ParticipantsCard',
  props: {
    participant: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ICON_COLOR_MAPPING,
    };
  },
  computed: {
    isRiseupCustomer() {
      return !!this.participant.customerId;
    },
  },
};
</script>

<style lang="scss">
@import '~base-ui/src/scss/riseup-colors';

.participant-card {
  width: 150px;
  height: 180px;
  position: relative;
  padding: 30px 0 16px;
  border: 1px solid $riseup_gray_1;
  box-shadow: 2px 2px 8px rgba(186, 188, 191, 0.25);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-family: SimplerPro;

  .riseup-badge {
    position: absolute;
    right: -10px;
    top: -10px;
  }

  .icon-circle {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .name {
    color: $riseup-black;
    font-weight: bold;
  }

  .spent {
    color: $riseup-blue;
  }
}

</style>
